import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Header } from 'components/common/header/Header';
import { useMeetingDetail } from 'hooks/useMeeting';
import { meetingStore } from 'store/meetingStore';
import './MeetingMap.css';

export const MeetingMap = () => {
    const navigate = useNavigate();
    const { meetingId } = useParams();
    const { data: meetingData } = useMeetingDetail();

    // 컴포넌트 마운트 시 모임 상세 정보 조회
    useEffect(() => {
        if (meetingId) {
            meetingStore.onGetMeetingDetail(meetingId);
        }
    }, [meetingId]);

    // API 데이터로부터 모임 정보 추출
    const meeting = meetingData?.data ? {
        id: meetingData.data.meetingId,
        name: meetingData.data.meetingName,
        location: meetingData.data.placeName || '장소 미정',
        locationDetail: meetingData.data.placeAddress || '',
        latitude: meetingData.data.latitude,
        longitude: meetingData.data.longitude
    } : {
        id: meetingId,
        name: '로딩 중...',
        location: '장소 미정',
        locationDetail: '',
        latitude: null,
        longitude: null
    };

    // 지도 URL 생성 (좌표가 있으면 좌표 사용, 없으면 주소 사용)
    const getMapUrl = () => {
        if (meeting.latitude && meeting.longitude) {
            return `https://maps.google.com/maps?q=${meeting.latitude},${meeting.longitude}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
        } else if (meeting.locationDetail) {
            return `https://maps.google.com/maps?q=${encodeURIComponent(meeting.locationDetail)}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
        } else {
            return `https://maps.google.com/maps?q=${encodeURIComponent(meeting.location)}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
        }
    };

    const getGoogleMapsUrl = () => {
        if (meeting.latitude && meeting.longitude) {
            return `https://maps.google.com/?q=${meeting.latitude},${meeting.longitude}`;
        } else if (meeting.locationDetail) {
            return `https://maps.google.com/?q=${encodeURIComponent(meeting.locationDetail)}`;
        } else {
            return `https://maps.google.com/?q=${encodeURIComponent(meeting.location)}`;
        }
    };

    return (
        <div className="meeting-map-wrapper">
            <Header title="위치 보기" isSubPage />

            <div className="meeting-map-content">
                <div className="meeting-map-info">
                    <h2 className="meeting-map-title">{meeting.name}</h2>
                    <p className="meeting-map-address">
                        <span className="address-icon">📍</span>
                        {meeting.locationDetail}
                    </p>
                </div>

                <div className="map-container">
                    <iframe
                        className="map-full-iframe"
                        src={getMapUrl()}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Meeting Location Full Map"
                    />
                </div>

                <div className="map-actions">
                    <button
                        className="map-action-button primary"
                        onClick={() => window.open(getGoogleMapsUrl(), '_blank')}
                    >
                        <span className="button-icon">🗺️</span>
                        <span className="button-text">Google Maps 앱에서 열기</span>
                    </button>

                    <button
                        className="map-action-button secondary"
                        onClick={() => navigate(`/meeting/detail/${meetingId}`)}
                    >
                        <span className="button-icon">←</span>
                        <span className="button-text">모임 상세로 돌아가기</span>
                    </button>
                </div>
            </div>
        </div>
    );
};
